const Forget = () => <>Forget</>;

export default Forget;
